import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

export default function ProductList() {
  const [products, setProducts] = useState([]);
  const [activeCategory, setActiveCategory] = useState("All");

  const API_BASE = import.meta.env.VITE_API_BASE_URL;

  const categories = ["All", "Massage Chair", "Shampoo Bed", "Pedicure Chair"];

  useEffect(() => {
    axios
      .get(`${API_BASE}/api/products`)
      .then((res) => setProducts(res.data))
      .catch(console.error);
  }, []);

  const filteredProducts =
    activeCategory === "All"
      ? products
      : products.filter((p) => p.category === activeCategory);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white pt-28 pb-16 px-5">

      {/* PAGE TITLE */}
      <h1 className="text-center text-4xl md:text-5xl font-bold tracking-tight mb-10 text-gray-900">
        Find Your Perfect Comfort
      </h1>

      {/* CATEGORY FILTERS */}
      <div className="flex justify-center flex-wrap gap-3 mb-12">
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => setActiveCategory(cat)}
            className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all border
              ${
                activeCategory === cat
                  ? "bg-gray-900 text-white border-gray-900 shadow-sm"
                  : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
              }
            `}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* PRODUCTS GRID */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
        {filteredProducts.map((p) => (
          <Link
            to={`/products/${p._id}`}
            key={p._id}
            className="group bg-white rounded-2xl border border-gray-200 shadow-sm 
                       hover:shadow-xl transition-all duration-300 p-5 hover:-translate-y-1"
          >
            {/* PRODUCT IMAGE */}
            <div className="w-full aspect-[4/3] overflow-hidden rounded-xl bg-gray-100 mb-4">
              <img
                src={p.images?.[0]}
                alt={p.name}
                className="w-full h-full object-cover group-hover:scale-105 transition duration-300"
              />
            </div>

            {/* PRODUCT INFO */}
            <h2 className="text-lg font-semibold text-gray-900">{p.name}</h2>
            <p className="text-gray-500 text-sm mt-1">{p.category}</p>

            {/* PRICE + STOCK */}
            <div className="flex items-center justify-between mt-4">
              <div className="text-[20px] font-bold tracking-tight text-gray-900">
                ${p.price}
              </div>

              {/* Stock Badge */}
              {p.stock <= 0 ? (
                <span className="text-red-600 font-medium text-sm">Out of stock</span>
              ) : p.stock <= 5 ? (
                <span className="text-yellow-600 font-medium text-sm">
                  Low ({p.stock})
                </span>
              ) : (
                <span className="text-green-600 font-medium text-sm">
                  {p.stock} in stock
                </span>
              )}
            </div>
          </Link>
        ))}
      </div>

      {/* EMPTY STATE */}
      {filteredProducts.length === 0 && (
        <p className="text-center text-gray-500 mt-12 text-lg">
          No products found in this category.
        </p>
      )}
    </div>
  );
}
